import CurrencyEntity from "../Entities/CurrencyEntity";
import OpportunityEntity from "../Entities/OpportunityEntity";
import Network from "../network/network";
import Util from "../util/Util";
import Logger, { Loglevel } from "../util/Logger";
import BaseService from "./BaseService";
import CurrencyService from "./CurrencyService";
import OpportunityModel from "../models/OpportunityModel";

export default class OpportunityService extends BaseService<OpportunityEntity> {
    private SERVICE_NAME = "OpportunityService";
    public static ODATA_ROUTE = "lead";

    private readonly currencyService: CurrencyService;
    private currencyEntityCache: CurrencyEntity[] = [];

    constructor(network: Network, currencyService: CurrencyService, logger: Logger) {
        super(network, logger);
        this.currencyService = currencyService;
    }

    protected getServiceName(): string {
        return this.SERVICE_NAME;
    }

    protected getOdataRoute(): string {
        return OpportunityService.ODATA_ROUTE;
    }

    protected mapDtoToEntity(dto: any): OpportunityEntity {
        return OpportunityEntity.fromOdata(dto, new OpportunityEntity());
    }

    public getPersonOpportunities = async (personId: number): Promise<OpportunityModel[]> => {
        return await this.getOpportunities(`PersonId eq ${personId}`);
    };

    public getInstitutionOpportunities = async (institutionId: number): Promise<OpportunityModel[]> => {
        return await this.getOpportunities(`InstitutionId eq ${institutionId}`);
    };

    public getOpportunityById = async (id: number) => {
        return Util.firstOrDefault(await this.getOpportunities(`Id eq ${id}`));
    };

    public getOpportunities = async (filter: string = ""): Promise<OpportunityModel[]> => {
        const currencies = await this.getCurrencies();
        const opportunityModels = (await this.getItems(filter)).map(op => new OpportunityModel(op, currencies));
        return opportunityModels;
    };

    public save = async (opportunity: OpportunityEntity): Promise<OpportunityEntity> => {
        try {
            const saved = await this.network.sendApi(this.getOdataRoute(), OpportunityEntity.toOdataObject(opportunity));
            return this.mapDtoToEntity(saved);
        } catch (e) {
            this.logger.log(Loglevel.Error, "Unable to save opportunity", e);
        }
    };

    private getCurrencies = async () => {
        if (!this.currencyEntityCache.length) {
            this.currencyEntityCache = await this.currencyService.getItems();
        }
        return this.currencyEntityCache;
    };

    protected getExpands = (): string[] => {
        return ["ContactPerson", "Institution", "Person"];
    };
}
